import React, { useMemo, useRef } from "react";
import BundledEditor from "./BundledEditor";
import "./style.css";

const TinyEditor = ({ editorState, onEditorStateChange, uploadImage }) => {
  const editorRef = useRef(null);

  const editorInit = useMemo(
    () => ({
      height: 400,
      menubar: true,
      automatic_uploads: true,
      plugins: [
        "advlist",
        "anchor",
        "autolink",
        "help",
        "image",
        "link",
        "lists",
        "searchreplace",
        "table",
        "wordcount",
        "directionality",
      ],
      toolbar:
        "undo redo | blocks | bold italic forecolor | " +
        "alignleft aligncenter alignright alignjustify | " +
        "ltr rtl | bullist numlist outdent indent | image | removeformat | help",
      file_picker_types: "image",
      content_style: `
        body {
          font-family: Helvetica, Arial, sans-serif;
          font-size: 14px;
        }
      `,
      convert_fonts_to_spans: true,
      formats: {
        alignleft: {
          selector: "p, h1, h2, div, ul, li",
          styles: { textAlign: "left" },
        },
        aligncenter: {
          selector: "p, h1, h2, div, ul, li",
          styles: { textAlign: "center" },
        },
        alignright: {
          selector: "p, h1, h2, div, ul, li",
          styles: { textAlign: "right" },
        },
        alignjustify: {
          selector: "p, h1, h2, div, ul, li",
          styles: { textAlign: "justify" },
        },
      },
      style_formats_merge: true,
      style_formats_autohide: false,
      images_upload_handler: uploadImage
        ? async (blobInfo) => uploadImage(blobInfo.blob())
        : undefined,
      file_picker_callback: uploadImage
        ? (callback, _value, meta) => {
          if (meta.filetype !== "image") {
            return;
          }

          const input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.onchange = async () => {
            const file = input.files?.[0];

            if (!file) {
              return;
            }

            try {
              const imageUrl = await uploadImage(file);
              callback(imageUrl, { alt: file.name });
            } catch (error) {
              window.alert(error?.message || "Image upload failed");
            }
          };
          input.click();
        }
        : undefined,
    }),
    [uploadImage]
  );

  return (
    <BundledEditor
      ref={editorRef}
      onInit={(_evt, editor) => {
        editorRef.current = editor;
      }}
      value={editorState || ""}
      rollback={false}
      onEditorChange={onEditorStateChange}
      init={editorInit}
    />
  );
};

export default TinyEditor;
